import React from "react";
import { Card, CardBody, CardTitle} from "@progress/kendo-react-layout";
import { Chip, ChipList } from "@progress/kendo-react-buttons";

const UserList = props => {

    const {
        title,
        data, 
        onDataRemoved,
      } = props;

    return <Card>
            <CardTitle>
                {title}:
            </CardTitle>
            <CardBody>
                {data && 
                    <ChipList
                        data={data}
                        chip={(props) => (
                        <Chip
                            {...props}
                            text={props.dataItem.name}
                            value={props.dataItem.id}
    //                      themeColor={"info"}
                            fillMode={"outline"}
                            rounded={"full"}
                            removable={true}
                            onRemove={onDataRemoved}
                        />
                        )}
                    />
                }
            </CardBody>
            </Card>;

};

export default UserList;